var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label",class:{
    'label-primary': _vm.value === 1,
    'label-info': _vm.value === 2,
    'label-danger': _vm.value === 3
  }},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }